import request from '../../request/request.js'
import qs from 'qs'


//获取消息数量
export const GetMessageSumAPI =()=> request.get(`/message/sum`)

//根据消息id删除消息

export const DeleteMsgByIdAPI =(friendId,msgId)=> request.delete(`/message/deleteMsgById/${friendId}/${msgId}`)